import axios from '../helpers/axios';
import { logError } from '../services';
import {
  IColorSchemeGeneralInfo,
  IColorSchemeGeneralInfoPut,
  IColorSchemesResponse,
  IDropdownResponse
} from '../models';

const baseUrl = '/api/color-schemes';

export const getColorSchemes = async (colorSchemeId: string | number): Promise<any> => {
  try {
    const { data } = await axios.get(`${baseUrl}/uris/${colorSchemeId}`);
    return data;
  } catch (error: any) {
    logError(error, 'getColorSchemes failed');
    return Promise.reject(error.response.data);
  }
};

export const getColorSchemeGeneralInfo = async (
  colorSchemeId: number | string
): Promise<IColorSchemeGeneralInfo> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${colorSchemeId}`);
    return data;
  } catch (error) {
    logError(error, 'getColorSchemeGeneralInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getColorSchemeOptionUris = async (
  colorSchemeOption: string,
  optionValue: string
): Promise<any> => {
  try {
    const { data } = await axios.get(`${baseUrl}/uris/${colorSchemeOption}/${optionValue}`);
    return data;
  } catch (error) {
    logError(error, 'getColorSchemeOptionUris failed');
    return Promise.reject(error?.response?.data);
  }
};

export const putColorSchemeGeneralInfo = async (
  colorSchemeId: number | string,
  payload: IColorSchemeGeneralInfoPut
): Promise<any> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${colorSchemeId}`, payload);
    return data;
  } catch (error) {
    logError({ error, payload: payload }, 'putColorSchemeGeneralInfo failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getColorSchemesList = async (filters?: {
  searchText?: string;
  page?: string | number;
  perPage?: string | number;
  isActive?: boolean;
}): Promise<IColorSchemesResponse> => {
  try {
    const { data } = await axios.get(`${baseUrl}`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getColorSchemesList failed');
    return Promise.reject(error);
  }
};

export const getColorSchemeOption = async (colorSchemeOption: string): Promise<any> => {
  try {
    const { data } = await axios.get(`${baseUrl}/selection/${colorSchemeOption}`);
    return data;
  } catch (error) {
    logError(error, 'getColorSchemeOption failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getColorSchemeAreas = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/color-scheme-areas`);
    return data;
  } catch (error) {
    logError(error, 'getColorSchemeAreas failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createColorScheme = async (payload: any) => {
  try {
    const result = await axios.post(`${baseUrl}`, payload);
    return result.data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          ...payload
        }
      },
      'createColorScheme failed'
    );
    return Promise.reject(error?.response?.data);
  }
};
